
import { Component, Prop, Vue } from "vue-property-decorator";

import Preloader from "@/components/Preloader.vue";
import CPositionLevelEquipment from "./Equipment.vue";

import StructureEquipment from "@/models/structure/equipment";
import PositionLocalLevel from "@/models/position/level";
import PositionLocalLevelWorkplace from "@/models/position/level_workplace";

import positionRoutes from "@/api/routes/positions";
import structureRoutes from "@/api/routes/structures";

@Component({
  name: "CPositionLevelWorkline",
  components: {
    Preloader,
    CPositionLevelEquipment
  }
})
export default class CPositionLevelWorkline extends Vue {
  @Prop({ required: true }) protected workline_id!: string;

  protected preload: boolean = false;
  protected equipments: StructureEquipment[] = [];
  protected position_levels: PositionLocalLevel[] = [];

  protected watchers: Function[] = [];

  protected async created() {
    this.preload = true;

    this.watchers.push(
      this.$store.watch(
        state => state.editedTreeLevel,
        (editedTreeLevel: PositionLocalLevelWorkplace) => {
          let check_self = false;

          if (
            editedTreeLevel.workline_id === this.workline_id &&
            !editedTreeLevel.equipment_id
          ) {
            check_self = true;
          }

          editedTreeLevel.levels.forEach(level => {
            const index = this.position_levels.findIndex(
              pl => pl.id === level.id
            );

            if (check_self) {
              if (index === -1) {
                this.position_levels.push({
                  id: level.id!,
                  level_id: level.level_id!,
                  workplace_id: editedTreeLevel.id,
                  structure_name: editedTreeLevel.structure_name,
                  level_name: level.level_name!
                });
              }
            } else {
              if (index !== -1) {
                this.$delete(this.position_levels, index);
              }
            }
          });

          editedTreeLevel.deletedLevels.forEach(level_id => {
            const index = this.position_levels.findIndex(
              pl => pl.id === level_id
            );

            if (index !== -1) {
              this.$delete(this.position_levels, index);
            }
          });
        }
      )
    );

    await Promise.all([this.loadLevels(), this.loadEquipments()]);

    this.preload = false;
  }

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected allowWrite() {
    return this.$api.allowWrite();
  }

  protected async loadEquipments() {
    return this.$api
      .get(structureRoutes.equipments, {
        params: { workline_id: this.workline_id }
      })
      .then(({ data: res }: { data: StructureEquipment[] }) => {
        res.forEach(r => (r.is_show = false));

        this.equipments = res;
      });
  }

  protected async toggleEquipment(equipment_index: number) {
    const equipment = this.equipments[equipment_index];

    equipment.is_show = !equipment.is_show;
  }

  protected async loadLevels() {
    return this.$api
      .get(positionRoutes.levels_tree, {
        params: {
          workline_id: this.workline_id
        }
      })
      .then(({ data: res }: { data: PositionLocalLevel[] }) => {
        this.position_levels = res;
      });
  }

  protected beforeUpdateLevel(level_index: number) {
    const level = this.position_levels[level_index];

    this.$store.commit("editTreeLevel", level);
  }
}
